import { Loader2 } from 'lucide-react';

export default function LoadingState() {
  return (
    <div className="text-center py-16">
      <Loader2 className="inline-block animate-spin text-[#3498DB] mb-4" size={48} />
      <p className="text-lg font-medium text-[#2C3E50]">
        Checking compatibility...
      </p>
      <p className="text-sm text-[#64748B] mt-2">
        This takes about 30 seconds
      </p>
    </div>
  );
}
